'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BlueTextButton = require('./components/BlueTextButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_BlueTextButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-buttons/lib/components/blue-text-button/index.js
// module id = 1034
// module chunks = 1